export function toggleLegendKey(activeKeys = [], key) {
  if (!key) return activeKeys;
  const hasKey = activeKeys.includes(key);
  if (hasKey) {
    const filtered = activeKeys.filter((item) => item !== key);
    return filtered.length === 0 ? activeKeys : filtered;
  }
  return [...activeKeys, key];
}




